import { GenericComment, GenericCommentObjectType } from '../Types/genericComment';
import { get, getQSFromObject, post, httpDelete } from './common';
import { transformDateStringPropsToDate } from '../Utils/dateUtils';

const genericCommentEndpoint = 'api/genericcomment';

const mapComment = (comment: GenericComment | null): GenericComment | null => {
    if (!comment) return null;
    return transformDateStringPropsToDate(comment, ['Date']);
};

const commentArrayMapper = (comments: GenericComment[] | null): GenericComment[] => {
    if (!comments) return [];
    return comments.map((comment) => mapComment(comment)!);
};

export async function getComments(objectType: GenericCommentObjectType, objectId: number) {
    const endpoint = `${genericCommentEndpoint}/GetComments?${getQSFromObject({ objectType, objectId })}`;
    const result = await get<GenericComment[]>(endpoint);
    return commentArrayMapper(result);
}

export async function addComment(comment: Partial<GenericComment>) {
    const endpoint = `${genericCommentEndpoint}/AddComment`;
    const result = await post<GenericComment>(endpoint, comment);
    return mapComment(result ?? null);
}

export async function updateComment(comment: Partial<GenericComment>) {
    const endpoint = `${genericCommentEndpoint}/UpdateCommentText`;
    const result = await post<GenericComment>(endpoint, comment);
    return mapComment(result ?? null);
}

export async function deleteComment(commentId: number) {
    const endpoint = `${genericCommentEndpoint}/DeleteComment?${getQSFromObject({ commentId })}`;
    const result = await httpDelete(endpoint);
    return result;
}